import React, { useState, useEffect } from "react"
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  TextField,
  Typography,
  InputAdornment,
  IconButton,
} from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import { setUser } from "../utils/auth"
import { passwordValidation } from "../components/account/SettingsPassword"
import APIS from "../utils/APIS"
import queryString from "query-string"

const RegisterCandidat = () => {
  const navigate = useNavigate();
  const [alertMessage, setAlertMessage] = useState()

  // Point 16 : icone œil sur tous les champs de mot de passe
  const [showPassword, setShowPassword] = useState(false)

  const [isValidRequest, setIsValidRequest] = useState(null)
  const [infos, setInfos] = useState({})
  useEffect(() => {
    const urlParams = queryString.parse(location.search)
    window.history.replaceState(null, null, window.location.pathname)
    if (urlParams.i && urlParams.email && urlParams.otp) {
      //on va vérifier que les infos sont correctes
      APIS.checkRegisterCandidat({email : urlParams.email, id : urlParams.i, otp: urlParams.otp}).then((result) => {
        if (result?.message === "checkRegisterCandidat") {
          setInfos({
            id : urlParams.i,
            email : urlParams.email,
            otp : urlParams.otp,
          })
          setIsValidRequest(true)
        } else {
          setIsValidRequest(false)
        }
      })
    } else {
      setIsValidRequest(false)
    }
  }, [])

  return (
    <>
      <Helmet>
        <title>Création compte | TheScan</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center'
        }}
      >
        <Container maxWidth="sm">
          {isValidRequest === "final" &&
            <Box sx={{ mb: 3, textAlign:"center" }}>
              {/* Point 13 : un titre qui dit ce qui se passe */}
              <Typography
                color="textBlack"
                variant="h2"
              >
                Votre compte est créé
              </Typography>
              <Typography
                color="textPrimary"
                gutterBottom
                mt={2}
                variant="body2"
              >
                Votre compte est prêt. Vous pouvez vous connecter dès maintenant.
              </Typography>
              <Box sx={{ py: 2 }}>
                <RouterLink to="/login">
                  <Button
                    color="primary"
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                    endIcon={<ChevronRightIcon/>}
                  >
                    Se connecter
                  </Button>
                </RouterLink>
              </Box>
            </Box>
          }
          {isValidRequest === false &&
            <Box sx={{ mb: 3, textAlign:"center" }}>
              <Typography
                color="textBlack"
                variant="h2"
              >
                Création compte
              </Typography>
              <Typography
                color="textPrimary"
                gutterBottom
                variant="body2"
              >
                Ce lien n'est plus valable. Si vous avez déjà créé votre compte, connectez-vous. Sinon, demandez à la personne qui vous a invité de vous renvoyer l'invitation.
              </Typography>
            </Box>
          }
          {isValidRequest === true &&
            <Formik
              initialValues={{
                firstName : '',
                name : '',
                password : '',
                confirm : '',
              }}
              validationSchema={Yup.object().shape({
                firstName: Yup.string().min(2, "Votre prénom est requis").max(255).required('Votre prénom est requis'),
                name: Yup.string().min(2, "Votre nom est requis").max(255).required('Votre nom est requis'),
                password: Yup.string()
                  .min(8, passwordValidation.min)
                  .matches(passwordValidation.regex, passwordValidation.matches)
                  .required(passwordValidation.required),
                confirm: Yup.string()
                  .oneOf([Yup.ref('password')], "Les deux mots de passe ne correspondent pas")
                  .required("Veuillez confirmer votre mot de passe"),
              })}
              onSubmit={(values, { setSubmitting }) => {
                setAlertMessage("");
                // S13 : le mot de passe est defini directement a l'inscription
                const vals = { id : infos?.id, email: infos?.email, otp : infos?.otp, firstName: values.firstName, name: values.name, password : values.password }
                APIS.validRegisterCandidat(vals).then(result => {
                  if (result?.message === "validRegisterCandidat") {
                    setIsValidRequest("final")
                  } else {
                    setAlertMessage("Erreur");
                    setSubmitting(false);
                  }
                })

              }}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                setFieldValue,
                handleSubmit,
                isSubmitting,
                touched,
                values
              }) => (
                <form onSubmit={handleSubmit}>
                  <Box sx={{ mb: 3, textAlign:"center" }}>
                    <Typography
                      color="textBlack"
                      variant="h2"
                    >
                      Avant de commencer
                    </Typography>
                    <Typography
                      color="textPrimary"
                      gutterBottom
                      variant="body2"
                    >
                      Nous avons besoin de quelques informations
                    </Typography>
                  </Box>

                  {/* Point 16 : l'adresse du compte en lecture seule — le
                      candidat sait sur quelle adresse son compte est cree */}
                  <TextField
                    fullWidth
                    label="Adresse email du compte"
                    margin="normal"
                    value={infos?.email || ""}
                    variant="outlined"
                    InputProps={{ readOnly: true }}
                    disabled
                  />

                  <Box sx={{display:"flex", gap:"15px"}}>
                    <TextField
                      error={Boolean(touched.firstName && errors.firstName)}
                      fullWidth
                      helperText={touched.firstName && errors.firstName}
                      label="Prénom"
                      margin="normal"
                      name="firstName"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type="text"
                      value={values.firstName}
                      variant="outlined"
                    />
                    <TextField
                      error={Boolean(touched.name && errors.name)}
                      fullWidth
                      helperText={touched.name && errors.name}
                      label="Nom"
                      margin="normal"
                      name="name"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type="text"
                      value={values.name}
                      variant="outlined"
                    />
                  </Box>
                  {/* Point 16 : œil pour afficher la saisie, et la regle du
                      mot de passe annoncee en permanence sous le champ, pas
                      seulement au moment de l'erreur */}
                  <TextField
                    error={Boolean(touched.password && errors.password)}
                    fullWidth
                    helperText={(touched.password && errors.password) || passwordValidation.matches}
                    label="Mot de passe"
                    margin="normal"
                    name="password"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type={showPassword ? "text" : "password"}
                    value={values.password}
                    variant="outlined"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="afficher le mot de passe"
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                  <TextField
                    error={Boolean(touched.confirm && errors.confirm)}
                    fullWidth
                    helperText={touched.confirm && errors.confirm}
                    label="Confirmer le mot de passe"
                    margin="normal"
                    name="confirm"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type={showPassword ? "text" : "password"}
                    value={values.confirm}
                    variant="outlined"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="afficher le mot de passe"
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                  <Box sx={{ py: 2 }}>
                    <Button
                      color="primary"
                      disabled={isSubmitting}
                      fullWidth
                      size="large"
                      type="submit"
                      variant="contained"
                      endIcon={<ChevronRightIcon/>}
                    >
                      Créer mon compte
                    </Button>
                  </Box>
                  {alertMessage && alertMessage.length > 0 && (
                    <Box
                      sx={{
                        pb: 1,
                        pt: 2
                      }}
                    >
                      <Typography
                        align="center"
                        color="red"
                        variant="body1"
                      >
                        {alertMessage}
                      </Typography>
                    </Box>
                  )}
                </form>
              )}
            </Formik>
          }
        </Container>
      </Box>
    </>
  );
};

export default RegisterCandidat;
